import Styled from "styled-components";

export const Container = Styled.div`
  position: relative;
  padding: 6.5rem 0 8rem;
  background: radial-gradient(rgb(68, 20, 187), rgb(23, 9, 56) 50%, rgb(4, 4, 4), rgb(3, 3, 3));
  color: #FFF;

  ${(props) => props.theme.breakpoints.up("medium")} {
   padding: 12rem 0 14rem;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
   padding: 10rem 0 12rem;
  }
`;

export const Content = Styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${(props) => props.theme.width};
  max-width: calc(100% - 2.5rem);
  margin: 0 auto;
  
  ${(props) => props.theme.breakpoints.up("medium")} {
    max-width: calc(100% - 10rem);
  }
`;

export const Header = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 5rem;
`;

export const HeadlineContainer = Styled.div`
  background: -webkit-linear-gradient(#FFFFFF, #9A7FD6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export const DescriptionContainer = Styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  gap: 3.75rem;
  text-align: center;

  p {
    color: #FFFFFF;
  }

  ${(props) => props.theme.breakpoints.up("medium")} {
    gap: 1.875rem;
  }
`;

export const Link = Styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-decoration: none;
`;
